/**
 * 优惠券服务
 */

import { apiClient } from './api';

export interface CouponInfo {
  code: string;
  name: string;
  credits: number;
  description?: string;
  validFrom: string;
  validTo: string;
  onlyForNewUsers: boolean;
  maxUses?: number;
  currentUses: number;
  remainingUses?: number;
}

export interface UseCouponResponse {
  couponId: string;
  couponName: string;
  credits: number;
  newBalance: number;
}

export const couponService = {
  /**
   * 验证优惠券（不实际使用）
   */
  verifyCoupon: async (code: string): Promise<CouponInfo> => {
    const response = await apiClient.post('/coupon/verify', { code });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.message || '优惠券验证失败');
  },

  /**
   * 使用优惠券（兑换积分）
   */
  useCoupon: async (code: string): Promise<UseCouponResponse> => {
    const response = await apiClient.post('/coupon/use', { code });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.message || '优惠券使用失败');
  }
};

